var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"applicants-home"}},[_c('compliance-banner',{staticClass:"mb-6 pl-2 pr-2 text-align-left",attrs:{"showBanner":!_vm.SessionLocationRegistered}}),_c('LoanDeliveredDetail',{staticClass:"mb-4"}),_c('ApplicantLoansSimulator')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }